"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTitle = exports.getMessage = exports.getEventStatus = void 0;

var _react = _interopRequireDefault(require("react"));

var _timeProvider = require("../time-provider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEventStatus = function getEventStatus(payload) {
  var eventData = payload.data;

  if (!eventData) {
    return null;
  }

  var _eventData$duration = eventData.duration,
      duration = _eventData$duration === void 0 ? '20' : _eventData$duration,
      isoDate = eventData.isoDate,
      timeString = eventData.timeString;
  var correctDate = isoDate || timeString;
  var durationMM = parseInt(duration, 10);
  var checkStatus = (0, _timeProvider.createScheduleEvent)(correctDate, durationMM);
  var now = (0, _timeProvider.getCurrentLocalISO)();
  var status = checkStatus(now);
  return status;
};

exports.getEventStatus = getEventStatus;

var getMessage = function getMessage(content, status) {
  if (status === 'before') {
    try {
      var data = content.data;
      var local = (0, _timeProvider.convertEventTimeToLocal)(data.isoDate);
      return "This activity is not available yet. Please try again ".concat(local.date, " at ").concat(local.time);
    } catch (err) {
      return 'This activity is not available yet. Please try again later';
    }
  }

  if (status === 'after') {
    return 'Sorry. This activity is over.';
  }

  if (status === 'archived') {
    return /*#__PURE__*/_react.default.createElement("span", null, "Event moved to the archive. Checkout", ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: "http://gitnation.org",
      target: "_blank"
    }, "http://gitnation.org"), ' ', "for future events.");
  }
};

exports.getMessage = getMessage;

var getTitle = function getTitle(content) {
  try {
    return (content.data.title || content.data.linkText).replace(/(<([^>]+)>)/gi, '');
  } catch (err) {
    return 'Activity';
  }
};

exports.getTitle = getTitle;